/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentEditorsScholarshipTypesQueryResponse,
  GetApiV1IndividualpaymentEditorsScholarshipTypesQueryParams,
  GetApiV1IndividualpaymentEditorsScholarshipTypes401,
  GetApiV1IndividualpaymentEditorsScholarshipTypes500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsScholarshipTypes.ts";

function getGetApiV1IndividualpaymentEditorsScholarshipTypesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/editors/scholarship-types` as const,
  };
  return res;
}

/**
 * @description Empresa com igualdade exata (sem 'companyId' retorna apenas bolsas sem empresa). 'scholarshipTypeId' inclui bolsa inativa já vinculada ao plano. Migrado do legado ScholarshipType/GetDropDownList. **(Requer Authorization para autenticação)**
 * @summary Bolsas disponíveis por empresa (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/scholarship-types}
 */
export async function getApiV1IndividualpaymentEditorsScholarshipTypes(
  params?: GetApiV1IndividualpaymentEditorsScholarshipTypesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentEditorsScholarshipTypesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsScholarshipTypes401
      | GetApiV1IndividualpaymentEditorsScholarshipTypes500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentEditorsScholarshipTypesUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
